module.exports = __webpack_public_path__ + "static/media/address.769a69e6.svg";